import { SmartSiteBaseApiV2 } from "../SmartSiteBaseApiV2";
import { Methods } from '@newview/infrastructure';
export class WorkplaceBasicInfoApi extends SmartSiteBaseApiV2 {

  public get ControllerName(): any {
    return 'workplaceBasicInfo';
  }

  public GetMiniProgramQrCode(data) {
    return this.send(data, "GetMiniProgramQrCodeBytesUnlimited", Methods.POST)
  }

  public getPersonInforList(WPId) {
    return this.send({WPId:WPId}, "getPersonInforList", Methods.GET)
  }
}